import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardActionArea,
  CardContent,
  Stack,
  SxProps,
  Typography,
  styled,
} from '@mui/material';

import { getSubjectColorNew } from '../../../../../helper';
import { TP_COLORS } from '../../../../../constants';
import { ICourseForAdmin } from '../../../../../store/V2/CoursesSlice';

interface CourseCardProps {
  course: ICourseForAdmin;
}

// const BorderLinearProgress = styled(LinearProgress)(() => ({
//   height: 6,
//   borderRadius: 5,
//   [`&.${linearProgressClasses.colorPrimary}`]: {
//     backgroundColor: '#F1F5F9',
//   },
//   [`& .${linearProgressClasses.bar}`]: {
//     borderRadius: 5,
//     backgroundColor: '#1E293B',
//   },
// }));

const cardContainerStyles: SxProps = {
  borderRadius: '7px',
  backgroundColor: '#ffffff',
  border: '1px solid transparent',
  transition: 'all ease-out 0.3s',
  '&:hover': {
    borderColor: '#CBD5E1',
    backgroundColor: '#ffffff',
    boxShadow: '0px 14px 40px 0px #6E9DB22E',
  },
};

const actionAreaStyles: SxProps = {
  backgroundColor: '#ffffff !important',
  '&:hover': { backgroundColor: '#ffffff !important' },
};

// const chipStyles: SxProps = {
//   backgroundColor: '#1E293B',
//   color: TP_COLORS.white,
//   borderRadius: '4px',
//   fontSize: '12px',
//   padding: '5px 0',
//   fontWeight: 500,
//   height: 'unset',
// };

const CustomCardActionArea = styled(CardActionArea)({
  '.MuiCardActionArea-focusHighlight': {
    background: '#ffffff',
  },
});

const CourseCard: React.FC<CourseCardProps> = ({ course }) => {
  const navigate = useNavigate();

  let formatedDuration = '';
  let formatedAmount = '';

  const numberOfClasses = course.noOfClasses || 0;
  const subjectColor = course.subject
    ? getSubjectColorNew(course.subject)
    : '#1C9FF7';

  const cardHeaderStyles: SxProps = {
    background: `url('${process.env.PUBLIC_URL}/images/shapes/card-waves.png') left center/auto no-repeat, ${subjectColor}`,
    borderRadius: '7px',
  };

  if (course.duration) {
    const _totalClassDuration = course.duration * numberOfClasses;

    const _hours = Math.floor(_totalClassDuration / 60);
    const _mins = _totalClassDuration % 60;

    if (_hours) {
      formatedDuration = `${_hours} hr`;

      if (_mins) {
        formatedDuration += ` ${_mins} min`;
      }
    } else {
      formatedDuration += ` ${_mins} min`;
    }
  }

  if (course.currency && course.amount) {
    const _amount = parseFloat(course.amount.toFixed(2)).toString();

    formatedAmount = `${course.currency} ${_amount}`;
  }

  return (
    <Card elevation={0} sx={cardContainerStyles}>
      <CustomCardActionArea
        disableRipple
        disableTouchRipple
        sx={actionAreaStyles}
        onClick={() =>
          navigate(`${process.env.PUBLIC_URL}/portal/courses/${course._id}`)
        }
      >
        <CardContent style={{ padding: '0 4px 0 4px' }}>
          <div style={{ padding: '15px 6px' }}>
            {/* CARD HEADER */}
            <Card elevation={0} sx={cardHeaderStyles}>
              <CardContent>
                {/* <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {true ? <Chip sx={chipStyles} label="Enrolled" /> : <div />}
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      console.log('hear clicked');
                    }}
                  >
                    <FavoriteIcon style={{ color: TP_COLORS.white }} />
                  </IconButton>
                </Stack> */}
                <div>
                  <Typography
                    color={TP_COLORS.white}
                    fontWeight={600}
                    fontSize="16px"
                    className="ellipsis-text .two-lines"
                    minHeight="50px"
                  >
                    {course.title}
                  </Typography>
                </div>
              </CardContent>
            </Card>
            {/* CARD CONTENT */}
            <div style={{ padding: '0 5px 10px 5px' }}>
              <div
                style={{
                  minHeight: '50px',
                  maxHeight: '50px',
                  overflow: 'hidden',
                  fontWeight: 600,
                  fontSize: '16px',
                  marginBottom: '10px',
                }}
              >
                <div
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: course.description || '-',
                  }}
                />
              </div>
              <div style={{ marginBottom: '10px' }}>
                <Typography color="#647488" fontSize="14px" fontWeight={500}>
                  {numberOfClasses} Class
                  {numberOfClasses > 1 ? 'es' : ''}
                  {formatedDuration ? ` | ${formatedDuration}` : null}
                </Typography>
              </div>
              <div>
                <Stack direction="row" alignItems="center">
                  <Typography
                    color={subjectColor}
                    fontWeight={700}
                    fontSize="18px"
                    minHeight="30px"
                  >
                    {formatedAmount}
                  </Typography>
                  {/* &nbsp; &nbsp;
                    <del>
                      <Typography
                        color="#647488"
                        fontWeight={400}
                        fontSize="16px"
                      >
                        SGD 12.00
                      </Typography>
                    </del> */}
                </Stack>
              </div>
              {/* {false && (
                <div style={{ marginBottom: '10px' }}>
                  <Stack>
                    <BorderLinearProgress
                      variant="determinate"
                      value={40}
                      style={{ marginBottom: '5px' }}
                    />
                    <Typography
                      variant="caption"
                      color="#647488"
                      fontWeight={500}
                      fontSize="14px"
                    >
                      10% complete
                    </Typography>
                  </Stack>
                </div>
              )} */}
            </div>
          </div>
        </CardContent>
      </CustomCardActionArea>
    </Card>
  );
};

export default CourseCard;
